'use client';

import { ExpandMore } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { useState } from 'react';
import { Details } from '../../../Details';

export function MoreAuthorsAccordion({
  numberOfAdditionalAuthors,
}: {
  numberOfAdditionalAuthors: number;
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  if (numberOfAdditionalAuthors === 0) {
    return null;
  }
  return (
    <Details
      variant="simple"
      detailsProps={{
        onToggle: ({ newState }) => setIsExpanded(newState === 'open'),
      }}
      SummaryComponent={
        <>
          <Typography
            variant="notesSmall"
            sx={{ fontWeight: 500 }}
          >{`+ ${numberOfAdditionalAuthors} more`}</Typography>
          <ExpandMore className="expand-icon" sx={{ fontSize: '18px', color: 'white' }} />
        </>
      }
      summaryComponentProps={{
        'data-testid': 'mobile-author-byline-summary',
        'aria-controls': 'mobile-author-byline-extra-authors',
        'aria-expanded': isExpanded,
        id: 'mobile-author-byline-summary',
        sx: {
          marginLeft: 2,
          width: 'fit-content',
          height: 'fit-content',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          '&:hover': {
            outline: '1px solid',
            outlineColor: 'limes.tintLP2',
            outlineOffset: '4px',
          },
        },
      }}
    />
  );
}
